//icons
import {
    DiReact,
    DiPostgresql,
    DiNodejsSmall,
    DiCss3,
    DiHtml5,
    DiJqueryLogo
} from 'react-icons/di'
import { SiMui } from 'react-icons/si'
import { BiLogoTypescript, BiLogoJavascript } from 'react-icons/bi'

const tools = [
    {
        id: 1,
        title: "JavaScript",
        placement: "left",
        color: "#fcdd00",
        href: "https://www.javascript.com/",
        icon: <BiLogoJavascript size="4em" />,
    },
    {
        id: 2,
        title: "React",
        placement: "top",
        color: "#149eca",
        href: "https://react.dev/",
        icon: <DiReact size="4em" />
    },
    {
        id: 3,
        title: "TypeScript",
        placement: "right",
        color: "#2596be",
        href: "https://www.typescriptlang.org/",
        icon: <BiLogoTypescript size="4em" />
    },
    {
        id: 4,
        title: "HTML5",
        placement: "left",
        color: "#e5522d",
        href: "https://www.w3schools.com/html/default.asp",
        icon: <DiHtml5 size="4em" />
    },
    {
        id: 5,
        title: "jQuery",
        placement: "bottom",
        color: "#78cff5",
        href: "https://jquery.com/",
        icon: <DiJqueryLogo size="4em" />
    },
    {
        id: 6,
        title: "CSS3",
        placement: "right",
        color: "#1572b7",
        href: "https://www.w3schools.com/css/",
        icon: <DiCss3 size="4em" />
    },
    {
        id: 7,
        title: "Node.js",
        placement: "left",
        color: "#88cc34",
        href: "https://nodejs.org/en",
        icon: <DiNodejsSmall size="4em" />
    },
    {
        id: 8,
        title: "Material UI",
        placement: "bottom",
        color: "#147fff",
        href: "https://mui.com/",
        icon: <SiMui size="4em" />
    },
    {
        id: 9,
        title: "PostgreSQL",
        placement: "right",
        color: "#386494",
        href: "https://www.postgresql.org/",
        icon: <DiPostgresql size="4em" />
    }
]

export default tools;